/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type AgendaItemStatus =
	(typeof AgendaItemStatus)[keyof typeof AgendaItemStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgendaItemStatus = {
	suggested: 'suggested',
	open: 'open',
	actively_discussing: 'actively_discussing',
	finalized: 'finalized',
	rejected: 'rejected',
	cancelled: 'cancelled',
	snoozed: 'snoozed',
} as const;
